<template>
 <div>
   <b-tag type="is-success" v-if="isGamePlaying(game)">
      elapsed time
      {{ getHoursElapsed(game) }}
      <span class="blink">:</span>
      {{ getMinutesElapsed(game) }}
    </b-tag>

    <b-tag type="" v-if="isGameStopped(game)">
      game lasted
      {{ game.gameLength }}
    </b-tag>
 </div>
</template>

<script>
  import gameHelper from '../../helpers/game-helper'

  // eslint-disable-next-line no-unused-vars
  import { Tag } from 'buefy'

  export default {
    name: 'GameTimer',
    props: {
      game: {
        gameStatus: '',
        timer: {
          hoursElapsed: 0,
        }
      }
    },
    methods: {
      getHoursElapsed(game) {
        return ('0' + game.timer.hoursElapsed).slice(-2)
      },
      getMinutesElapsed(game) {
        return ('0' + game.timer.minutesElapsed).slice(-2)
      },
      isGameStopped: gameHelper.isGameStopped,
      isGamePlaying: gameHelper.isGamePlaying,
    }
  }
</script>

<style scoped>
  .blink {
    animation: blinker 1.5s cubic-bezier(.5, 0, 1, 1) infinite alternate;
  }

  @keyframes blinker {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  .timer {
    margin-right: 25px;
    font-weight: bold;
    color: white;
    background-color: grey;
    text-align: center;
    vertical-align: middle;
    line-height: 20px;
  }

  .timer-stopped {
    margin-right: 25px;
    font-weight: bold;
    color: white;
    background-color: #e3b100;
    text-align: center;
    vertical-align: middle;
    line-height: 20px;
  }

</style>
